const STATUS_MODIFIER = {
    UP: 'up',
    DOWN: 'down',
    OUT_OF_SERVICE: 'down',
    UNKNOWN: 'unknown',
    UNAVAILABLE: 'warning',
};

export const getStatusModifier = (value) => {
    if (!value) {
        return 'unknown';
    }
    return STATUS_MODIFIER[value.toUpperCase()] || 'unknown';
};

export const formatStatusLabel = (value) => {
    const label = value || 'UNKNOWN';
    return label.replace(/_/g, ' ');
};

const statusUtils = {
    getStatusModifier,
    formatStatusLabel,
};

export default statusUtils;
